(function () {
  function initStoryVideos(root) {
    root.querySelectorAll('[data-mm-story-video]').forEach(function (video) {
      if (!video.dataset.observed && 'IntersectionObserver' in window) {
        video.dataset.observed = 'true';
        const observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!video.isConnected) { observer.disconnect(); return; }
            if (!entry.isIntersecting) { video.pause(); return; }
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
                (navigator.connection && navigator.connection.saveData)) return;
            video.play().catch(function () { /* tap-to-play covers blocked autoplay */ });
          });
        }, { threshold: 0.25 });
        observer.observe(video);

        // Native controls are hidden — tapping the video starts it if autoplay was blocked.
        video.addEventListener('click', function () {
          if (video.paused) video.play().catch(function () {});
        });
      }

      const wrap = video.closest('.mm-story-media');
      const soundBtn = wrap && wrap.querySelector('[data-mm-sound-toggle]');
      if (soundBtn && !soundBtn.dataset.wired) {
        soundBtn.dataset.wired = 'true';
        soundBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          soundBtn.classList.toggle('is-on', !video.muted);
          soundBtn.setAttribute('aria-pressed', String(!video.muted));
          soundBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          if (!video.muted && video.paused) video.play().catch(function () {});
        });
      }
    });
  }
  initStoryVideos(document);
  document.addEventListener('shopify:section:load', function (event) { initStoryVideos(event.target); });

  const drawer = document.getElementById('mm-drawer');
  const overlay = document.getElementById('mm-overlay');
  const searchPanel = document.getElementById('mm-search-panel');
  const cartDrawer = document.getElementById('mm-cart-drawer');
  const cartBody = cartDrawer ? cartDrawer.querySelector('#mm-cart-drawer-body') : null;
  const cartFoot = cartDrawer ? cartDrawer.querySelector('#mm-cart-drawer-foot') : null;
  const emailForm = document.querySelector('.mm-email-form');
  const formNote = document.querySelector('[data-form-note]');

  // Free-shipping threshold in cents. Match the "over $75" announcement.
  const FREE_SHIP_CENTS = 7500;
  let drawerIso = 'USD';

  function drawerMoney(cents) { return money(cents, drawerIso); }

  // Instant optimistic repaint of every visible drawer line + subtotal + ship bar.
  function paintDrawerLocal() {
    if (!cartBody) return;
    var total = 0, count = 0;
    cartBody.querySelectorAll('.mm-cart-drawer-item').forEach(function (row) {
      var unit = parseInt(row.dataset.price, 10) || 0;
      var input = row.querySelector('input');
      var q = input ? (parseInt(input.value, 10) || 0) : 0;
      total += unit * q;
      count += q;
      var priceEl = row.querySelector('.mm-cart-drawer-price');
      if (priceEl) priceEl.textContent = drawerMoney(unit * q);
    });
    var sub = cartFoot && cartFoot.querySelector('.mm-cart-drawer-sub strong');
    if (sub) sub.textContent = drawerMoney(total);
    var shipBox = cartBody.querySelector('.mm-ship-progress');
    if (shipBox) shipBox.innerHTML = shipProgressHtml(total, drawerIso);
    return { total: total, count: count };
  }

  function closePanels() {
    if (drawer) {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.hidden = true;
      if (drawer.hasAttribute('inert')) { /* already inert */ } else { drawer.setAttribute('inert', ''); }
    }
    if (searchPanel) {
      searchPanel.classList.remove('open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchPanel.hidden = true;
      if (searchPanel.hasAttribute('inert')) { /* already inert */ } else { searchPanel.setAttribute('inert', ''); }
    }
    closeCartDrawer();
    // Only drop the overlay if nothing else is open.
    if (overlay && !drawer.classList.contains('open') && !searchPanel.classList.contains('open') && !(cartDrawer && cartDrawer.classList.contains('open'))) {
      overlay.classList.remove('open');
    }
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.hidden = true;
    cartDrawer.setAttribute('inert', '');
  }

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('hidden');
    drawer.removeAttribute('inert');
    overlay.classList.add('open');
  }

  function openSearch() {
    if (!searchPanel || !overlay) return;
    searchPanel.classList.add('open');
    searchPanel.setAttribute('aria-hidden', 'false');
    searchPanel.removeAttribute('hidden');
    searchPanel.removeAttribute('inert');
    overlay.classList.add('open');
    const input = searchPanel.querySelector('input');
    window.setTimeout(function () {
      if (input) input.focus();
    }, 120);
  }

  document.querySelectorAll('[data-open-drawer]').forEach(function (button) {
    button.addEventListener('click', openDrawer);
  });
  document.querySelectorAll('[data-open-search]').forEach(function (button) {
    button.addEventListener('click', openSearch);
  });
  document.querySelectorAll('[data-close-panels]').forEach(function (button) {
    button.addEventListener('click', closePanels);
  });
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.mm-nav a, .mm-drawer nav a');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const href = link.getAttribute('href');
    if (!href || href === '#') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = link.href;
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePanels();
  });

  if (emailForm && formNote) {
    emailForm.addEventListener('submit', function () {
      formNote.textContent = 'Thank you. Your private edit is reserved.';
      formNote.style.color = 'var(--mm-success)';
    });
  }

  // ---- Predictive Search (Shopify Predictive Search API) ----
  const psInput = searchPanel ? searchPanel.querySelector('input[type="search"]') : null;
  const psBox = searchPanel ? searchPanel.querySelector('#mm-search-suggest') : null;
  if (psInput && psBox) {
    const MOCK = [
      ['Contour Lace Balconette', 'TBC'],
      ['Satin Sleep Shirt', 'TBC'],
      ['Everyday Mesh Brief', 'TBC'],
      ['Soft Modal Robe', 'TBC'],
      ['Sheer Lace Bodysuit', 'TBC'],
      ['Lace-Trim Bralette', 'TBC'],
      ['Long Lace Robe', 'TBC'],
      ['Lace Trim Sleep Set', 'TBC']
    ];
    let psTimer;
    function renderSuggest(html) {
      psBox.innerHTML = html;
      psBox.hidden = !html.trim();
    }
    function mockSuggest(q) {
      const hits = MOCK.filter(function (p) {
        return p[0].toLowerCase().indexOf(q.toLowerCase()) !== -1;
      }).slice(0, 6);
      if (!hits.length) { renderSuggest('<p class="mm-predictive-empty">No suggestions</p>'); return; }
      let ul = '<ul class="mm-predictive-list">';
      hits.forEach(function (p) {
        ul += '<li><a href="/search?q=' + encodeURIComponent(q) + '" class="mm-predictive-item">' +
              '<span class="mm-predictive-text"><span class="mm-predictive-title">' + p[0] + '</span>' +
              '<span class="mm-predictive-price">' + p[1] + '</span></span></a></li>';
      });
      ul += '</ul>';
      renderSuggest(ul);
    }
    psInput.addEventListener('input', function () {
      clearTimeout(psTimer);
      const q = psInput.value.trim();
      if (q.length < 2) { psBox.hidden = true; psBox.innerHTML = ''; return; }
      psTimer = setTimeout(function () {
        const url = '/search/suggest?q=' + encodeURIComponent(q) +
                    '&section_id=predictive-search&resources[limit]=6&resources[type]=product&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (text) {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const node = doc.querySelector('.mm-predictive');
            if (node && node.innerHTML.trim()) {
              renderSuggest(node.innerHTML);
            } else {
              mockSuggest(q);
            }
          })
          .catch(function () { mockSuggest(q); });
      }, 300);
    });
    psBox.addEventListener('click', function (e) {
      const a = e.target.closest('a');
      if (a && a.getAttribute('href')) { window.location.href = a.getAttribute('href'); }
    });
    psInput.addEventListener('blur', function () {
      setTimeout(function () { psBox.hidden = true; }, 180);
    });
    psInput.addEventListener('focus', function () {
      if (psBox.innerHTML.trim()) psBox.hidden = false;
    });
  }

  // ---- Mini-cart drawer ----
  function money(cents, iso) {
    try {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: iso || 'USD' });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function updateCartBadge(count) {
    document.querySelectorAll('.mm-cart-count').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  function shipProgressHtml(totalCents, iso) {
    var remaining = Math.max(0, FREE_SHIP_CENTS - totalCents);
    var pct = Math.min(100, Math.round((totalCents / FREE_SHIP_CENTS) * 100));
    var label = remaining > 0
      ? 'Add <strong>' + money(remaining, iso) + '</strong> for free shipping'
      : 'You&rsquo;ve unlocked free shipping';
    return '<div class="mm-ship-bar"><span style="width:' + pct + '%"></span></div><p>' + label + '</p>';
  }

  // cart.js 的 line item 不返回 variant 对象，
  // 库存上限优先用 variant，回落到 Liquid 注入的 window.MM_STOCK。
  function stockMaxFor(item) {
    if (item && item.variant && item.variant.inventory_management === 'shopify') {
      return item.variant.inventory_quantity;
    }
    var m = window.MM_STOCK && window.MM_STOCK[String(item && item.variant_id)];
    return (typeof m === 'number') ? m : null;
  }

  function renderMiniCart(cart) {
    // Guard: never wipe the drawer on an unexpected/error payload.
    if (!cart || typeof cart.item_count !== 'number') return;
    var iso = (cart.currency && cart.currency.iso_code) || 'USD';
    drawerIso = iso;
    if (!cart.item_count) {
      cartBody.innerHTML = '<p class="mm-cart-drawer-empty">Your bag is empty.</p>';
      cartFoot.innerHTML = '';
      return;
    }
    var rows = '<ul class="mm-cart-drawer-list">';
    cart.items.forEach(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + (item.product_title || '').replace(/"/g, '') + '">'
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p>' + item.variant_title + '</p>' : '';
      var maxQty = stockMaxFor(item);
      var maxAttr = (maxQty !== null && maxQty > 0) ? ' max="' + maxQty + '"' : '';
      var stockHint = (maxQty !== null && maxQty > 0 && maxQty <= 10)
        ? '<p style="margin:4px 0 0;font-size:12px;color:#a4323e;">Only ' + maxQty + ' in stock</p>' : '';
      rows += '<li class="mm-cart-drawer-item" data-key="' + item.key + '" data-price="' + item.final_price + '"'
        + (maxQty !== null ? ' data-max="' + maxQty + '"' : '') + '>' +
        '<a class="mm-cart-drawer-thumb" href="' + item.url + '">' + img + '</a>' +
        '<div class="mm-cart-drawer-info">' +
          '<a class="mm-cart-drawer-title" href="' + item.url + '">' + item.product_title + '</a>' +
          variant + stockHint +
          '<div class="mm-qty-stepper">' +
            '<button type="button" class="mm-qty-btn" data-step="down" aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" class="mm-cart-drawer-qty" value="' + item.quantity + '" min="1"' + maxAttr + ' step="1" inputmode="numeric">' +
            '<button type="button" class="mm-qty-btn" data-step="up" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="mm-cart-drawer-right">' +
          '<span class="mm-cart-drawer-price">' + money(item.final_line_price, iso) + '</span>' +
          '<button type="button" class="mm-cart-drawer-remove" data-key="' + item.key + '" aria-label="Remove item">&times;</button>' +
        '</div>' +
      '</li>';
    });
    rows += '</ul>';

    cartBody.innerHTML = '<div class="mm-ship-progress">' + shipProgressHtml(cart.total_price, iso) + '</div>' + rows;

    cartFoot.innerHTML =
      '<div class="mm-cart-drawer-sub"><span>Subtotal</span><strong>' + money(cart.total_price, iso) + '</strong></div>' +
      '<p class="mm-cart-drawer-note">Shipping &amp; taxes calculated at checkout.</p>' +
      '<a class="mm-btn mm-cart-drawer-checkout" href="/checkout">Checkout</a>' +
      '<a class="mm-cart-drawer-view" href="/cart">View bag</a>';
  }

  let mmCartCache = null;

  function cartSkeletonHtml() {
    let rows = '';
    for (let i = 0; i < 3; i++) {
      rows += '<div class="mm-skel-row"><div class="mm-skel-thumb"></div>' +
        '<div class="mm-skel-lines"><span></span><span class="short"></span></div></div>';
    }
    return '<div class="mm-cart-skeleton" aria-hidden="true">' + rows + '</div>';
  }

  function loadMiniCart() {
    fetch((window.MM_ROUTES && window.MM_ROUTES.cart) || '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        mmCartCache = cart;
        renderMiniCart(cart);
        updateCartBadge(cart.item_count);
      })
      .catch(function () {});
  }

  function openMiniCart() {
    if (!cartDrawer || !cartBody) return;
    if (mmCartCache) {
      renderMiniCart(mmCartCache); // instant paint, refresh quietly below
    } else if (!cartBody.children.length) {
      cartBody.innerHTML = cartSkeletonHtml(); // never open blank
      cartFoot.innerHTML = '';
    }
    loadMiniCart();
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.removeAttribute('hidden');
    cartDrawer.removeAttribute('inert');
    if (overlay) overlay.classList.add('open');
  }

  function flashCartNotice(msg) {
    if (!cartBody) return;
    var note = document.createElement('p');
    note.className = 'mm-cart-drawer-note';
    note.style.color = '#a4323e';
    note.style.margin = '10px 0 0';
    note.textContent = msg;
    cartBody.insertBefore(note, cartBody.firstChild);
    setTimeout(function () { note.remove(); }, 4000);
  }

  // ---- Serialised cart writes -----------------------------------------------
  // Clicking +/- quickly used to fire one /cart/change.js per click; replies
  // could land out of order and repaint an older quantity, so the number
  // visibly "snapped back". We now allow a single request in flight and
  // coalesce further clicks into the latest target per line, then repaint from
  // server truth only once the queue drains.
  var cartWriteQueue = {}; // line key -> latest requested quantity
  var cartWriteBusy = false;

  function hasQueuedWrites() {
    for (var k in cartWriteQueue) {
      if (Object.prototype.hasOwnProperty.call(cartWriteQueue, k)) return true;
    }
    return false;
  }

  function changeCartItem(key, qty) {
    if (!key || !String(key).length) return;
    cartWriteQueue[key] = qty;
    pumpCartWrites();
  }

  function pumpCartWrites() {
    if (cartWriteBusy) return;
    var key = null;
    for (var k in cartWriteQueue) {
      if (Object.prototype.hasOwnProperty.call(cartWriteQueue, k)) { key = k; break; }
    }
    if (key === null) return;
    var qty = cartWriteQueue[key];
    delete cartWriteQueue[key];
    cartWriteBusy = true;
    sendCartItem(key, qty);
  }

  function sendCartItem(key, qty) {
    fetch((window.MM_ROUTES && window.MM_ROUTES.cart_change) || '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      // Shopify 只认 id（可为 line item key）或 line，不认 key 参数
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        cartWriteBusy = false;
        // Error payloads (e.g. 422 not enough stock) have no item_count:
        // restore the drawer from server truth instead of wiping it.
        if (!res.ok || !res.data || typeof res.data.item_count !== 'number') {
          if (hasQueuedWrites()) { pumpCartWrites(); } else { loadMiniCart(); }
          var reason = (res.data && (res.data.description || res.data.message)) || '';
          flashCartNotice(reason || 'Sorry \u2014 that quantity isn\u2019t available right now.');
          return;
        }
        mmCartCache = res.data;
        updateCartBadge(res.data.item_count);
        // Repaint only after the queue drains, so a burst of clicks never
        // flashes an older quantity; the optimistic UI covers the in-between.
        if (hasQueuedWrites()) { pumpCartWrites(); } else { renderMiniCart(res.data); }
      })
      .catch(function () {
        cartWriteBusy = false;
        if (hasQueuedWrites()) { pumpCartWrites(); } else { loadMiniCart(); }
      });
  }

  function clampQty(input) {
    var v = parseInt(input.value, 10) || 1;
    if (v < 1) v = 1;
    var max = parseInt(input.getAttribute('max'), 10);
    if (max && v > max) v = max;
    input.value = v;
    return v;
  }

  document.querySelectorAll('[data-open-cart]').forEach(function (button) {
    button.addEventListener('click', function (e) {
      // Let plain left-clicks open the drawer; modifier clicks still navigate to /cart.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      openMiniCart();
    });
  });
  document.querySelectorAll('[data-close-cart]').forEach(function (button) {
    button.addEventListener('click', closePanels);
  });

  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var stepBtn = e.target.closest('.mm-qty-btn');
      if (stepBtn) {
        var input = stepBtn.parentElement.querySelector('input');
        var li = stepBtn.closest('.mm-cart-drawer-item');
        var maxAvail = parseInt(li && li.dataset.max, 10);
        if (stepBtn.dataset.step === 'up' && maxAvail && parseInt(input.value, 10) >= maxAvail) {
          input.value = maxAvail;
          paintDrawerLocal();
          flashCartNotice('Only ' + maxAvail + ' left in stock.');
          return;
        }
        var cur = parseInt(input.value, 10) || 1;
        cur += stepBtn.dataset.step === 'up' ? 1 : -1;
        input.value = cur;
        var maxAttr = parseInt(input.getAttribute('max'), 10);
        if (stepBtn.dataset.step === 'up' && maxAttr && parseInt(input.value, 10) >= maxAttr) {
          input.value = maxAttr;
          paintDrawerLocal();
          flashCartNotice('Only ' + maxAttr + ' left in stock.');
          return;
        }
        var qty = clampQty(input);
        paintDrawerLocal(); // instant feedback while the request is in flight
        if (li && li.dataset.key) changeCartItem(li.dataset.key, qty);
        return;
      }
      var removeBtn = e.target.closest('.mm-cart-drawer-remove');
      if (!removeBtn) return;
      var row = removeBtn.closest('.mm-cart-drawer-item');
      var titleEl = row && row.querySelector('.mm-cart-drawer-title');
      mmConfirm({
        title: 'Remove item',
        message: 'Remove ' + ((titleEl && titleEl.textContent.trim()) || 'this item') + ' from your bag?'
      }).then(function (yes) {
        if (yes) changeCartItem(removeBtn.dataset.key, 0);
      });
    });
    cartBody.addEventListener('change', function (e) {
      var input = e.target.closest('.mm-cart-drawer-qty');
      if (!input) return;
      var li = input.closest('.mm-cart-drawer-item');
      var qty = clampQty(input);
      paintDrawerLocal(); // instant feedback while the request is in flight
      if (li && li.dataset.key) changeCartItem(li.dataset.key, qty);
    });
  }

  // ---- Branded confirm dialog (replaces the browser's window.confirm) ----
  const mmConfirmState = { overlay: null, done: null, lastFocus: null };

  function mmConfirmClose(result) {
    const st = mmConfirmState;
    if (!st.done) return;
    const settle = st.done;
    st.done = null;
    st.overlay.classList.remove('is-open');
    setTimeout(function () { st.overlay.hidden = true; }, 180);
    if (st.lastFocus && st.lastFocus.focus) st.lastFocus.focus();
    settle(result);
  }

  function mmConfirm(opts) {
    const o = (typeof opts === 'string') ? { message: opts } : (opts || {});
    const st = mmConfirmState;
    if (!st.overlay) {
      st.overlay = document.createElement('div');
      st.overlay.className = 'mm-modal-overlay';
      st.overlay.hidden = true;
      st.overlay.innerHTML =
        '<div class="mm-modal" role="dialog" aria-modal="true" aria-labelledby="mm-modal-title">' +
          '<h3 id="mm-modal-title"></h3>' +
          '<p></p>' +
          '<div class="mm-modal-actions">' +
            '<button type="button" class="mm-modal-cancel">Keep it</button>' +
            '<button type="button" class="mm-modal-confirm">Remove</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(st.overlay);
      st.overlay.addEventListener('click', function (e) {
        if (e.target === st.overlay || e.target.closest('.mm-modal-cancel')) mmConfirmClose(false);
        else if (e.target.closest('.mm-modal-confirm')) mmConfirmClose(true);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && st.done) mmConfirmClose(false);
      });
    }
    st.lastFocus = document.activeElement;
    st.overlay.querySelector('h3').textContent = o.title || 'Remove item';
    st.overlay.querySelector('p').textContent = o.message || '';
    st.overlay.querySelector('.mm-modal-cancel').textContent = o.cancelLabel || 'Keep it';
    st.overlay.querySelector('.mm-modal-confirm').textContent = o.confirmLabel || 'Remove';
    return new Promise(function (resolve) {
      st.done = resolve;
      st.overlay.hidden = false;
      requestAnimationFrame(function () { st.overlay.classList.add('is-open'); });
      st.overlay.querySelector('.mm-modal-cancel').focus();
    });
  }
  window.mmConfirm = mmConfirm;

  // ---- Product-card colour swatches -----------------------------------------
  // Each dot points at the product photo of that colour; clicking it swaps the
  // card cover. The cover is rendered with a srcset, so the swap has to drop
  // srcset/sizes — otherwise the browser keeps resolving the old image from
  // srcset and the click looks like it did nothing.
  function mmSwapCardCover(dot, img) {
    var url = dot.getAttribute('data-mm-img');
    if (!url || !img) return;
    var box = img.closest('.mm-product-photo');
    var done = false;

    function apply() {
      if (done) return;
      done = true;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.removeAttribute('loading');
      img.setAttribute('src', url);
      if (box) box.classList.remove('is-swapping');
    }

    if (box) box.classList.add('is-swapping');
    var pre = new Image();
    pre.onload = apply;
    pre.onerror = function () {
      done = true;
      if (box) box.classList.remove('is-swapping');
    };
    pre.src = url;
    if (pre.complete) apply();
  }

  function initCardSwatches(root) {
    (root || document).querySelectorAll('[data-mm-swatches]').forEach(function (group) {
      if (group.dataset.mmWired) return;
      group.dataset.mmWired = 'true';

      var card = group.closest('.mm-product-card');
      var img = card && card.querySelector('.mm-product-photo .mm-img');
      var dots = Array.prototype.slice.call(group.querySelectorAll('.mm-swatch'));
      if (!dots.length) return;

      // Warm the cache so the first click swaps without a visible wait.
      dots.forEach(function (dot) {
        var u = dot.getAttribute('data-mm-img');
        if (u) { var p = new Image(); p.src = u; }
      });

      function activate(dot) {
        dots.forEach(function (d) {
          d.classList.toggle('is-active', d === dot);
          d.setAttribute('aria-pressed', String(d === dot));
        });
      }

      // Mark whichever dot matches the cover already on screen.
      if (img) {
        var current = (img.getAttribute('src') || '').split('?')[0];
        var match = null;
        for (var i = 0; i < dots.length; i++) {
          var u = (dots[i].getAttribute('data-mm-img') || '').split('?')[0];
          if (u && u === current) { match = dots[i]; break; }
        }
        activate(match || dots[0]);
      }

      group.addEventListener('click', function (e) {
        var dot = e.target.closest('.mm-swatch');
        if (!dot || !group.contains(dot)) return;
        e.preventDefault();
        if (dot.classList.contains('is-active')) return;
        activate(dot);
        mmSwapCardCover(dot, img);
      });
    });
  }
  initCardSwatches(document);
  document.addEventListener('shopify:section:load', function (event) {
    initCardSwatches(event.target);
  });

  // Expose so the product page's add-to-bag handler can open the drawer.
  window.MonicaCart = {
    open: openMiniCart,
    setCache: function (cart) {
      if (cart && typeof cart.item_count === 'number') {
        mmCartCache = cart;
        renderMiniCart(cart);
      }
    },
    setStock: function (variantId, qty) {
      window.MM_STOCK = window.MM_STOCK || {};
      if (typeof qty === 'number') window.MM_STOCK[String(variantId)] = qty;
      else delete window.MM_STOCK[String(variantId)];
    }
  };
})();
